const API_URL = window.location.hostname === 'localhost' 
    ? '/api' 
    : import.meta.env.VITE_API_URL;

// Simple cache for API responses
const cache = new Map();

// Generate cache key from endpoint and parameters
const getCacheKey = (endpoint, params) => {
    return `${endpoint}-${params?.toString() || ''}`;
};

// Delay for better UX
const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

export const fetchNumberListings = async (params) => {
    const cacheKey = getCacheKey('numberListings', params);
    
    if (cache.has(cacheKey)) {
        await delay(300);
        return cache.get(cacheKey);
    }

    const response = await fetch(`${API_URL}/number-listings?${params.toString()}`);
    if (!response.ok) throw new Error('Network response was not ok');
    
    const { numberListings } = await response.json();
    cache.set(cacheKey, numberListings);
    return numberListings;
}

export const getStoreData = async (storeID) => {
    const cacheKey = getCacheKey('storeData', storeID);
    
    if (cache.has(cacheKey)) {
        return cache.get(cacheKey);
    }

    const response = await fetch(`${API_URL}/stores/${storeID}`);
    if (!response.ok) throw new Error('Network response was not ok');
    
    const data = await response.json();
    cache.set(cacheKey, data);
    return data;
}

export const orderRequest = async ({ msisdn, contactNumber, name, onlinePayment, hppRedirectUrl }) => {
    const response = await fetch(`${API_URL}/order-request`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ msisdn, contactNumber, name, hppRedirectUrl }),
    });
    if (!response.ok) {
        const text = await response.text().catch(() => '');
        throw new Error(`Failed to submit order-request (${response.status}). ${text}`);
    }
    return response.json();
};